/**
 * Dependencies.
 */
import { BaseModel } from '@prz-dp/services';

import ServicePointModel from './service-point.model';

/**
 * Model `AddressModel`.
 */
export default class AddressModel extends BaseModel {
  /**
   * Properties.
   */
  additionalInformation: string;

  city: string;

  countryCode: string;

  countryName: string;

  doorNumber: string;

  latitude: number;

  longitude: number;

  servicePoint?: ServicePointModel;

  street: string;

  zipCode: string;

  /**
   * Constructor.
   */
  constructor(data: Partial<AddressModel>) {
    super(data);
  }
}
